export default {"src":"/_next/static/media/kinetek-logo.a202c9eb.svg","height":48,"width":40,"blurWidth":0,"blurHeight":0};